import script from "./down.vue?vue&type=script&setup=true&lang=js"
export * from "./down.vue?vue&type=script&setup=true&lang=js"

import "./down.vue?vue&type=style&index=0&id=5ac561eb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ac561eb"]])

export default __exports__